import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  onClick?: () => void;
}
const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  onClick
}) => {
  const baseClasses = 'font-medium rounded-full transition-all duration-200 inline-flex items-center justify-center';
  const sizeClasses = {
    sm: 'px-4 py-1.5 text-sm',
    md: 'px-5 py-2',
    lg: 'px-6 py-3 text-base'
  };
  const variantClasses = {
    primary: 'bg-primary hover:bg-primary/90 text-white shadow-sm',
    secondary: 'bg-accent hover:bg-accent/80 text-tertiary',
    outline: 'border border-primary/30 hover:border-primary text-primary hover:text-primary/80'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button onClick={onClick} className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${widthClass}`} data-id="element-990">
      {children}
    </button>;
};
export default Button;